<app-modal [isOpen]="isOpen" [className]="'max-w-lg p-6 sm:p-8'" (close)="close()">

    <div class="mb-5 pt-6 pr-10">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Registrar punto de partida</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Completa los datos del punto para registrarlo y seleccionarlo.</p>
    </div>

    <form (ngSubmit)="onSubmit()">
        <div class="space-y-4">

            <div>
                <app-label>Nombre <span class="text-error-500">*</span></app-label>
                <app-input-field [(value)]="name" name="name" placeholder="Ej: Almacén Callao" />
                @if (submitted && !name.trim()) {
                <p class="mt-1 text-sm text-error-500">El nombre es obligatorio</p>
                }
            </div>

            <div>
                <app-label>Dirección completa <span class="text-error-500">*</span></app-label>
                <app-input-field [(value)]="address" name="address" placeholder="Ej: Av. Principal 123, Urb. Ejemplo" />
                @if (submitted && !address.trim()) {
                <p class="mt-1 text-sm text-error-500">La dirección es obligatoria</p>
                }
            </div>

            <div>
                <app-label>Ubigeo <span class="text-error-500">*</span></app-label>
                <app-ubigeo-picker [(value)]="ubigeo" [ubigeos]="ubigeos" [loading]="loadingUbigeos"
                    placeholder="Seleccionar ubigeo..."></app-ubigeo-picker>
                @if (submitted && !ubigeo.trim()) {
                <p class="mt-1 text-sm text-error-500">El ubigeo es obligatorio</p>
                }
            </div>

            <div>
                <app-label>Código de establecimiento (SUNAT)</app-label>
                <app-input-field [(value)]="localCode" name="localCode"
                    placeholder="Ej: 0001 (obligatorio en traslado entre establecimientos)" />
            </div>

            <div class="flex items-center justify-end gap-3 pt-2 border-t border-gray-100 dark:border-gray-800">
                <button type="button" (click)="close()"
                    class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                    Cancelar
                </button>
                <button type="submit" [disabled]="isSubmitting"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50">
                    {{ isSubmitting ? 'Registrando...' : 'Registrar y seleccionar' }}
                </button>
            </div>

        </div>
    </form>

</app-modal>
